import convertRelationToQueryOptions from './query/convertRelationToQueryOptions';
import { IQueryKeyValue } from '@kurtosys/ksys-app-template/dist/models/query';
import pivotQueryCollection from './query/pivotQueryCollection';
import { SegmentationFilter } from '../models/configuration/SegmentationFilter';
import { DataStore } from '../stores';
import getQueryResults from './query/getQueryResults';
import { replacePlaceholders } from './replacePlaceholders';

export class Segmentation {
    public inclusionClauses: Array<string> = [];
    public exclusionClauses: Array<string> = [];
    private queriesById: IQueryKeyValue;
    private queryResults: any = undefined;
    constructor(
        private filter: SegmentationFilter | undefined,
        private dataStore: DataStore
    ) {
        this.loadQueries();
        this.loadQueryResults();
    }
    public orchestrateList(list: Array<string>) {
        const orchestratedList = (list || []).map(item => {
            const parsedItem = replacePlaceholders({
                values: this.queryResults || {},
                text: item,
                appParams: this.dataStore.appDataProps,
            });
            return parsedItem;
        });
        return orchestratedList;
    }
    private loadQueries() {
        if (this.filter && this.filter.queries) {
            const queryOptions = convertRelationToQueryOptions(
                this.filter.queries
            );
            this.queriesById = pivotQueryCollection(queryOptions);
        }
    }
    private loadQueryResults() {
        this.queryResults = getQueryResults(
            {},
            this.queriesById,
            null,
            this.dataStore.appDataProps
        );
    }
}



// WEBPACK FOOTER //
// ./src/utils/Segmentation.ts